import React, {useState} from "react";
import ParticipantEntry from "./ParticipantEntry";
import IconClose from "../../Icons/IconClose";

const ParticipantSelectorPopup = (props) => {

  const {
    types,
    onChange,
    onClose
  } = props;

  const setParticipantsFor = (id, val) => {
    const newSelection = [];
    types.map((entry) => {
      if (entry.id === id) {
        entry.value = val;
      }
      newSelection.push(entry);
    });
    if (onChange) {
      onChange(newSelection);
    }
  }

  const handleClear = () => {
    const newSelection = [];
    types.map((entry) => {
      entry.value = 0;
      newSelection.push(entry);
    });
    if (onChange) {
      onChange(newSelection);
    }
  };

  return <>
    <div className="passengerPopup">
      <div className="passengerPopup__wrap">
        <div className="passengerPopup__header">
          <div className="passengerPopup__heading">
            <h5>Passengers</h5>
          </div>
          <div className="passengerPopup__close" onClick={onClose}>
            <IconClose />
          </div>
        </div>
        <div className="passengerPopup__body">
          {(types && types.length > 0) && <div>
            {types.map((item) => {
              return <ParticipantEntry
                label={item.label}
                key={item.id}
                value={item.value}
                description={item.description}
                onChange={(val) => {
                  setParticipantsFor(item.id, val);
                }}
              />
            })}
          </div>}
        </div>
        <div className="passengerPopup__footer">
          <div className="passengerPopup__footer__wrap">
            <div className="passengerPopup__clear" onClick={handleClear}>
              <p>Clear</p>
            </div>
            {/*<div className="passengerPopup__cansel">*/}
            {/*  <button*/}
            {/*    className="btn btn--lg btn--stroke"*/}
            {/*    onClick={onClose}>*/}
            {/*    Cancel*/}
            {/*  </button>*/}
            {/*</div>*/}
            <div className="passengerPopup__apply">
              <div
                className="btn btn--lg"
                onClick={onClose}>
                Apply
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>

}

export default ParticipantSelectorPopup;
